export default {
  name: "DetailsCard",

  props: {
    accordion_id: { type: String, required: true },

    full_name: { type: String, default: "N/A" },
    role: { type: String, default: "N/A" },
    status: { type: String, default: "on-site" },

    hours: String,
    address: String,
    website: String,
    phone: String,
    email: String,

    defaultOpen: { type: Boolean, default: false }
  },

  data() {
    return ({
      is_open: this.defaultOpen
    });
  },

  methods: {
    toggle() {
      this.is_open = !this.is_open;
    },

    open() {
      this.is_open = true;
    },

    close() {
      this.is_open = false;
    }
  },

  computed: {
    initials() {
      const parts = (this.full_name || "").trim().split(" ");
      return (
        (parts[0]?.[0] || "") +
        (parts[parts.length - 1]?.[0] || "")
      ).toUpperCase();
    },

    status_label() {
      if (this.status === "break") return "Break";
      if (this.status === "off-site") return "Off-Site";
      return "On-Site";
    },

    status_dot_class() {
      if (this.status === "break") return "is-break";
      if (this.status === "off-site") return "is-offsite";
      return "is-onsite";
    },

    safe_website() {
      if (!this.website) return "#";
      return this.website.startsWith("http")
        ? this.website
        : `https://${this.website}`;
    }
  }
};
